/**
 * Status badge/text helpers shared by ClientQueue subcomponents
 */

import type { TFunction } from 'i18next';

export const getStatusBadge = (status: string) => {
  const badges: Record<string, string> = {
    waiting: 'bg-accent/10 text-accent border border-accent/30',
    notified: 'bg-accent/15 text-accent border border-accent/40',
    arrived: 'bg-success/10 text-success border border-success/30',
    in_service: 'bg-info/10 text-info border border-info/30',
  };
  return badges[status] || 'bg-surface-2 text-ink-muted border border-hairline';
};

export const getStatusText = (status: string, t: TFunction): string => {
  const key = `queueManagement.barberInterface.statuses.${status}`;
  const translated = t(key);
  return translated !== key ? translated : status;
};
